import { render, staticRenderFns } from "./ForceTransactionUpdate.vue?vue&type=template&id=73f72b38"
import script from "./ForceTransactionUpdate.vue?vue&type=script&lang=js"
export * from "./ForceTransactionUpdate.vue?vue&type=script&lang=js"
import style0 from "./ForceTransactionUpdate.vue?vue&type=style&index=0&id=73f72b38&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports